import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import ActivityIcon from "src/assets/all-icons/activity-icon.jsx";
import ArtworkIcon from "src/assets/all-icons/artwork-icon.jsx";
import CollectionIcon from "src/assets/all-icons/collection-icon.jsx";
import HelpCenterIcon from "src/assets/all-icons/help-center-icon.jsx";
import InvoicesIcon from "src/assets/all-icons/invoices-icon.jsx";
import OrdersIcon from "src/assets/all-icons/orders-icon.jsx";
import SettingsIcon from "src/assets/all-icons/settings-icon.jsx";
import SuarteRoadIcon from "src/assets/all-icons/suarte-road-icon.jsx";

import SaveArtworkIcon from '@/assets/all-icons/save-artwork-icon';
import UserIcon from '@/assets/all-icons/user-icon';
import Text from '@/shared-components/text/components/Text';

import './styles/ProfileOptions.css';

export default function ProfileOptions({ fetchData, open, setOpen }) {
  useEffect(()=>{
    if(open === true) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [open]);

  useEffect(()=>{
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, []);

  if(!open) {
    return <></>;
  } else if(fetchData.user_type === "artist" || fetchData.user_type === "collector") {
    return createPortal(
      <>
        <div className="profile-options__background" onClick={()=>setOpen(false)}>
          <div className="profile-options__options-outter">
            <div className="profile-options__options">
              <Link className="profile-options__option" to="suarte-road" state={{ from: true }}>
                <Text className="profile-options__option-text delay1" small>
                                    Suarte Road
                </Text>

                <div className="profile-options__option-icon-container delay1">
                  <SuarteRoadIcon className="profile-options__option-icon"/>
                </div>
              </Link>

              <Link className="profile-options__option" to="my-collection" state={{ from: true }}>
                <Text className="profile-options__option-text delay1" small>
                                    My Collection
                </Text>

                <div className="profile-options__option-icon-container delay1">
                  <CollectionIcon className="profile-options__option-icon"/>
                </div>
              </Link>

              <Link className="profile-options__option" to="/orders/pending" state={{ from: true }}>
                <Text className="profile-options__option-text delay2" small>
                                    Orders
                </Text>

                <div className="profile-options__option-icon-container delay2">
                  <OrdersIcon className="profile-options__option-icon"/>
                </div>
              </Link>

              <Link className="profile-options__option" to="activity" state={{ from: true }}>
                <Text className="profile-options__option-text delay3" small>
                                    Activity
                </Text>

                <div className="profile-options__option-icon-container delay3">
                  <ActivityIcon className="profile-options__option-icon"/>
                </div>
              </Link>

              <Link className="profile-options__option" to="activity/saved-artworks" state={{ from: true }}>
                <Text className="profile-options__option-text delay4" small>
                                    Saved artworks
                </Text>

                <div className="profile-options__option-icon-container delay4">
                  <SaveArtworkIcon className="profile-options__option-icon"/>
                </div>
              </Link>

              <Link className="profile-options__option" to="settings" state={{ from: true }}>
                <Text className="profile-options__option-text delay5" small>
                                    Settings
                </Text>

                <div className="profile-options__option-icon-container delay5">
                  <SettingsIcon className="profile-options__option-icon"/>
                </div>
              </Link>
              <a className="profile-options__option" href="https://help.suarte.art" target="_blank" rel="noreferrer" >
                <Text className="profile-options__option-text delay6" small>
                                    Help Center
                </Text>

                <div className="profile-options__option-icon-container delay6">
                  <HelpCenterIcon className="profile-options__option-icon stroke-0"/>
                </div>
              </a>
            </div>
          </div>
        </div>
      </>, document.getElementById("portal-profile-options")
    );
  } else {
    return createPortal(
      <>
        <div className="profile-options__background" onClick={()=>setOpen(false)}>
          <div className="profile-options__options-outter">
            <div className="profile-options__options">
              <Link className="profile-options__option" to="/inventory/available" state={{ from: true }}>
                <Text className="profile-options__option-text delay1" small>
                                    Inventory
                </Text>

                <div className="profile-options__option-icon-container delay1">
                  <ArtworkIcon className="profile-options__option-icon"/>
                </div>
              </Link>
    
              <Link className="profile-options__option" to="/orders/pending" state={{ from: true }}>
                <Text className="profile-options__option-text delay2" small>
                                    Orders
                </Text>

                <div className="profile-options__option-icon-container delay2">
                  <OrdersIcon className="profile-options__option-icon"/>
                </div>
              </Link>
    
              <Link className="profile-options__option" to="activity" state={{ from: true }}>
                <Text className="profile-options__option-text delay3" small>
                                    Activity
                </Text>

                <div className="profile-options__option-icon-container delay3">
                  <ActivityIcon className="profile-options__option-icon"/>
                </div>
              </Link>
    
              <Link className="profile-options__option" to="invoices" state={{ from: true }}>
                <Text className="profile-options__option-text delay4" small>
                                    Invoices
                </Text>

                <div className="profile-options__option-icon-container delay4">
                  <InvoicesIcon className="profile-options__option-icon"/>
                </div>
              </Link>
    
              <Link className="profile-options__option" to="activity/saved-artworks" state={{ from: true }}>
                <Text className="profile-options__option-text delay5" small>
                                    Saved artworks
                </Text>

                <div className="profile-options__option-icon-container delay5">
                  <SaveArtworkIcon className="profile-options__option-icon saved"/>
                </div>
              </Link>
    
              <Link className="profile-options__option" to="referrals" state={{ from: true }}>
                <Text className="profile-options__option-text delay6" small>
                                    Referrals
                </Text>

                <div className="profile-options__option-icon-container delay6">
                  <UserIcon className="profile-options__option-icon referrals"/>
                </div>
              </Link>
    
              <Link className="profile-options__option" to="settings" state={{ from: true }}>
                <Text className="profile-options__option-text delay7" small>
                                    Settings
                </Text>
                                
                <div className="profile-options__option-icon-container delay7">
                  <SettingsIcon className="profile-options__option-icon"/>
                </div>
              </Link>

              <a className="profile-options__option"  href="https://help.suarte.art/galleries/" rel="noreferrer"  target="_blank">
                <Text className="profile-options__option-text delay6" small>
                                    Help Center
                </Text>

                <div className="profile-options__option-icon-container delay6">
                  <HelpCenterIcon className="profile-options__option-icon stroke-0"/>
                </div>
              </a>
            </div>
          </div>
        </div>
      </>, document.getElementById("portal-profile-options")
    );
  }
}
